var JENDCO_ALGOLIA_BLOCKED_BOT_UA = /baiduspider|ahrefsbot|semrushbot|mj12bot|dotbot|petalbot|blexbot|scrapy|python|curl|wget|headless|phantom|selenium|playwright/i;

if (JENDCO_ALGOLIA_BLOCKED_BOT_UA.test(navigator.userAgent)) {
  console.warn('Algolia disabled for crawler user agent:', navigator.userAgent);
  window.JENDCO_DISABLE_ALGOLIA = true;
}

if (!window.JENDCO_DISABLE_ALGOLIA) {

const urlParams = new URLSearchParams(window.location.search);
const initialQuery = urlParams.get('query') || '';
const suggestionContainer = document.querySelector('.search_collection-link__inner');
const suggestcollcontainer = document.querySelector('.search-suggestion-tab');
const isSearchPage = window.location.pathname === '/search';
var hide_filters = algolia_customs.hide_filters.split(',').map(item => item.toLowerCase().trim());
// var hide_filters = '';

const JENDCO_ALGOLIA_PROXY_URL = 'https://jendco-algolia-proxy.myron-2e0.workers.dev';

const searchClient = {
  search: function(requests) {
    return fetch(`${JENDCO_ALGOLIA_PROXY_URL}/search`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Jendco-Search-Client': 'storefront'
      },
      body: JSON.stringify({ requests: requests })
    }).then(function(response) {
      if (!response.ok) {
        return response.text().then(function(text) {
          throw new Error('Algolia proxy search failed: ' + response.status + ' ' + text);
        });
      }
      return response.json();
    });
  },

  searchForFacetValues: function(requests) {
    return fetch(`${JENDCO_ALGOLIA_PROXY_URL}/sffv`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Jendco-Search-Client': 'storefront'
      },
      body: JSON.stringify({ requests: requests })
    }).then(function(response) {
      if (!response.ok) {
        return response.text().then(function(text) {
          throw new Error('Algolia proxy SFFV failed: ' + response.status + ' ' + text);
        });
      }
      return response.json();
    });
  },

  addAlgoliaAgent: function() {
    // InstantSearch calls this on Algolia clients. No-op for proxy client.
  }
};


const search = instantsearch({
  indexName: 'jendco-shopify_products',
  searchClient: searchClient,
  routing: true,
  initialUiState: {
    shopify_products: {
      query: initialQuery,
    },
  },
});

const search_popular = instantsearch({
  indexName: 'jendco-shopify_products',
  searchClient: algoliasearch('SRQQCVINL7', 'cc4c95e5f685f38dcb80d39dac620913'),
});

const qsClient = algoliasearch(
  "SRQQCVINL7",
  "cc4c95e5f685f38dcb80d39dac620913"
).initIndex('jendco-shopify_products_query_suggestions');

const qscollClient = algoliasearch(
  "SRQQCVINL7",
  "cc4c95e5f685f38dcb80d39dac620913"
).initIndex('jendco-shopify_collections');

const {
  refinementList,
  dynamicWidgets,
  menu,
  hierarchicalMenu,
  searchBox,
  hits,
  pagination,
  configure,
  currentRefinements,
  clearRefinements,
} = instantsearch.widgets;
const {
  connectSortBy,
  connectSearchBox,
  connectStats,
  connectRange,
  connectCurrentRefinements,
  connectClearRefinements,
} = instantsearch.connectors;

const facetsWrappermobile = document.querySelectorAll('.mobile-facets__main-items ');
let sideFilterWrapper = document.querySelectorAll('.facets__wrapper-container');

const searchFilters = () => {
  let r = "";

  if (algolia_customs.collection) {
    r = "collections:" + algolia_customs.handle;
  }

  return r;
};

const renderStats = (renderOptions, isFirstRender) => {
  const {
    nbHits,
    areHitsSorted,
    nbSortedHits,
    processingTimeMS,
    query,
    widgetParams,
  } = renderOptions;

  if (isFirstRender) {
    return;
  }

  let count = "";
  let resultsText = "Results";

  //console.log('state call')

  if (areHitsSorted) {
    if (nbSortedHits > 1) {
      count = `${nbSortedHits}`;
    } else if (nbSortedHits === 1) {
      count = "1";
    } else {
      count = "No";
    }
    count += ` out of ${nbHits}`;
  } else {
    if (nbHits > 1) {
      count += `${nbHits}`;
    } else if (nbHits === 1) {
      count += "1";
    } else {
      count += "no result";
    }
  }
  widgetParams.container.setAttribute('data-count',count);
  if (query == " " || query == "") {
    widgetParams.container.innerHTML = `${count} products`;
  }else if(count == 'no result'){
    widgetParams.container.innerHTML = `0 products`;
  }else {
    widgetParams.container.innerHTML = `Showing ${nbHits} of ${count} products`;
  }

  
  
};

const renderSortBy = (renderOptions1, isFirstRender1) => {
  const { options, currentRefinement, refine, widgetParams, canRefine } =
  renderOptions1;

  if (isFirstRender1) {
    const select = document.createElement("ul");

    widgetParams.container.appendChild(select);

    const select2 = widgetParams.container.querySelector("ul");

    select2.classList.add("sort-by-dropdown");
    select2.classList.add("sort-options");
    select2.disabled = !canRefine;

    select2.innerHTML = `${options
      .map(
        (option) =>
          `<li onclick="closeActive(this)" data-value="${option.value}" class="${
            option.value === currentRefinement ? "active" : ""
          }"><span class="redio-icon"></span>${option.label}</li>`
      )
      .join("")}`;

    select.querySelectorAll("li").forEach(function (e) {
      e.addEventListener("click", (event) => {
        const li = event.currentTarget;
        document
          .querySelector("#sort-by1 li.active")
          ?.classList.remove("active");
        // event.target.classList.add("active");
        li.classList.add("active");
        // refine(event.target.dataset.value);
        refine(li.dataset.value);
      });
    });
  }
};

const renderSortBy2 = (renderOptions2, isFirstRender2) => {
  const { options, currentRefinement, refine, widgetParams, canRefine } =
    renderOptions2;

  if (isFirstRender2) {
    const select = document.createElement("ul");

    widgetParams.container.appendChild(select);

    const select2 = widgetParams.container.querySelector("ul");

    select2.classList.add("sort-by-dropdown");
    select2.classList.add("sort-options");
    select2.disabled = !canRefine;

    select2.innerHTML = `${options
      .map(
        (option) =>
          `<li onclick="closeActive(this)" data-value="${option.value}" class="${
            option.value === currentRefinement ? "active" : ""
          }"><span class="redio-icon"></span>${option.label}</li>`
      )
      .join("")}`;

    select.querySelectorAll("li").forEach(function (e) {
      e.addEventListener("click", (event) => {
        const li = event.currentTarget;
        document
          .querySelector("#sort-by2 li.active")
          ?.classList.remove("active");
        // event.target.classList.add("active");
        li.classList.add("active");
        // refine(event.target.dataset.value);
        refine(li.dataset.value);
      });
    });
  }
};

const renderSearchBox = (renderOptions, isFirstRender) => {
  const { query, refine, clear } = renderOptions;

  const container = document.querySelector("#searchbox");

  if (isFirstRender) {
    const box = document.createElement("div");
    const form = document.createElement("form");
    const input = document.createElement("input");
    const button = document.createElement("button");

    box.classList.add("ais-SearchBox");
    button.textContent = `<svg class="ais-SearchBox-resetIcon" viewBox="0 0 20 20" width="20" height="20"><path d="M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z"></path></svg>`;
    form.setAttribute("role", "search");

    input.addEventListener("input", (event) => {
      refine(event.target.value);
    });

    button.addEventListener("click", () => {
      clear();
    });

    form.appendChild(button);
    form.appendChild(input);
    box.appendChild(form);
    container.appendChild(box);
  }

  container.querySelector("input").value = query;
};

const renderRangeSlider = (renderOptions, isFirstRender) => {
  const { start, range, refine, widgetParams } = renderOptions;
  if (isFirstRender) {
    const inputTo = document.createElement("input");
    const inputFrom = document.createElement("input");
    const inputs = document.createElement("div");
    const h1_ele = document.createElement("h1");

    inputTo.type = "range";
    inputTo.min = 0;
    inputTo.max = Math.ceil(range.max / 5) * 5;
    inputTo.value = Number.isFinite(start[1])
      ? start[1]
      : Math.ceil(range.max / 5) * 5;
    inputTo.step = 5;
    inputTo.id = "toPrice";

    inputFrom.type = "range";
    inputFrom.min = 0;
    inputFrom.max = Math.ceil(range.max / 5) * 5;
    inputFrom.value = 0;
    inputFrom.value = Number.isFinite(start[0]) ? start[0] : "0";
    inputFrom.step = 5;
    inputFrom.id = "fromPrice";

    inputs.id = "priceLabels";

    widgetParams.container.appendChild(inputFrom);
    widgetParams.container.appendChild(inputTo);
    widgetParams.container.parentNode.appendChild(inputs);

    const fromSlider = widgetParams.container.querySelector("#fromPrice");
    const toSlider = widgetParams.container.querySelector("#toPrice");

    toSlider.addEventListener("change", (event) => {
      const changeFrom = document.querySelector("#fromPrice");
      const changeTo = document.querySelector("#toPrice");
      if (parseFloat(changeTo.value) < parseFloat(changeFrom.value)) {
        changeFrom.value = 0;
      }
      refine([
        parseFloat(changeFrom.value),
        parseFloat(event.currentTarget.value),
      ]);
      fillSlider(changeFrom, changeTo, "#C6C6C6", "#000000", changeTo);
    });

    fromSlider.addEventListener("change", (event) => {
      const changeFrom = document.querySelector("#fromPrice");
      const changeTo = document.querySelector("#toPrice");

      if (parseFloat(changeTo.value) < parseFloat(changeFrom.value)) {
        changeTo.value = changeFrom.max;
      }

      refine([
        parseFloat(event.currentTarget.value),
        parseFloat(changeTo.value),
      ]);
      fillSlider(changeFrom, changeTo, "#C6C6C6", "#D51317", changeTo);
    });

    fillSlider(fromSlider, toSlider, "#C6C6C6", "#D51317", toSlider);
  }

  const inputTo = widgetParams.container.querySelector("#toPrice");
  const inputFrom = widgetParams.container.querySelector("#fromPrice");

  inputTo.min = 0;
  inputTo.max = Math.ceil(range.max / 5) * 5;
  inputFrom.max = Math.ceil(range.max / 5) * 5;

  inputFrom.value = Number.isFinite(start[0]) ? start[0] : "0";
  inputTo.value = Number.isFinite(start[1])
    ? start[1]
    : Math.ceil(range.max / 5) * 5;


  widgetParams.container.parentNode.querySelector("#priceLabels").innerHTML = `
    <span>${start[0] == -Infinity ? 0 : start[0]}</span>
    <span>${
      start[1] == Infinity ? Math.ceil(range.max / 5) * 5 : start[1]
    }</span>
  `;

  fillSlider(inputFrom, inputTo, "#C6C6C6", "#D51317", inputTo);
};

const renderRangeSliderMobile = (renderOptions, isFirstRender) => {
  const { start, range, refine, widgetParams } = renderOptions;
  if (isFirstRender) {
    const inputTo = document.createElement("input");
    const inputFrom = document.createElement("input");
    const inputs = document.createElement("div");

    inputTo.type = "range";
    inputTo.min = 0;
    inputTo.max = Math.ceil(range.max / 5) * 5;
    inputTo.value = Number.isFinite(start[1]) ? start[1] : Math.ceil(range.max / 5) * 5;
    inputTo.step = 5;
    inputTo.id = "toPriceMobile";

    inputFrom.type = "range";
    inputFrom.min = 0;
    inputFrom.max = Math.ceil(range.max / 5) * 5;
    inputFrom.value = Number.isFinite(start[0]) ? start[0] : "0";
    inputFrom.step = 5;
    inputFrom.id = "fromPriceMobile";

    inputs.id = "priceLabels-mobile";

    widgetParams.container.appendChild(inputFrom);
    widgetParams.container.appendChild(inputTo);
    widgetParams.container.parentNode.appendChild(inputs);

    const fromSlider = widgetParams.container.querySelector("#fromPriceMobile");
    const toSlider = widgetParams.container.querySelector("#toPriceMobile");

    toSlider.addEventListener("change", (event) => {
      const changeFrom = document.querySelector("#fromPriceMobile");
      const changeTo = document.querySelector("#toPriceMobile");
      if (parseFloat(changeTo.value) < parseFloat(changeFrom.value)) {
        changeFrom.value = 0;
      }
      refine([parseFloat(changeFrom.value), parseFloat(event.currentTarget.value)]);
      fillSlider(changeFrom, changeTo, "#C6C6C6", "#000000", changeTo);
    });

    fromSlider.addEventListener("change", (event) => {
      const changeFrom = document.querySelector("#fromPriceMobile");
      const changeTo = document.querySelector("#toPriceMobile");
      if (parseFloat(changeTo.value) < parseFloat(changeFrom.value)) {
        changeTo.value = changeFrom.max;
      }
      refine([parseFloat(event.currentTarget.value), parseFloat(changeTo.value)]);
      fillSlider(changeFrom, changeTo, "#C6C6C6", "#D51317", changeTo);
    });

    fillSlider(fromSlider, toSlider, "#C6C6C6", "#D51317", toSlider);
  }

  const inputTo = widgetParams.container.querySelector("#toPriceMobile");
  const inputFrom = widgetParams.container.querySelector("#fromPriceMobile");

  if (!inputTo || !inputFrom) return;

  inputTo.min = 0;
  inputTo.max = Math.ceil(range.max / 5) * 5;
  inputFrom.max = Math.ceil(range.max / 5) * 5;

  inputFrom.value = Number.isFinite(start[0]) ? start[0] : "0";
  inputTo.value = Number.isFinite(start[1]) ? start[1] : Math.ceil(range.max / 5) * 5;

  widgetParams.container.parentNode.querySelector("#priceLabels-mobile").innerHTML = `
    <span>${start[0] == -Infinity ? 0 : start[0]}</span>
    <span>${start[1] == Infinity ? Math.ceil(range.max / 5) * 5 : start[1]}</span>
  `;

  fillSlider(inputFrom, inputTo, "#C6C6C6", "#D51317", inputTo);
};

const renderCurrentRefinements = (renderOptions, isFirstRender) => {
  const { items, canRefine, refine, createURL, widgetParams } = renderOptions;

  if (isFirstRender) {
    // Do some initial rendering and bind events
  }

  document.querySelector("#current-refinements").innerHTML = `
    <ul class="ais-CurrentRefinements-list">
      ${items.map(renderListItem).join("")}
    </ul>
  `;

  const clear_buttons = document.querySelectorAll(
    ".ais-CurrentRefinements-category"
  );

  clear_buttons.forEach((element) => {
    element.addEventListener("click", (event) => {
      const item = Object.keys(event.currentTarget.dataset).reduce(
        (acc, key) => ({
          ...acc,
          [key]: event.currentTarget.dataset[key],
        }),
        {}
      );

      refine(item);

      if (item.attribute == "price") {
        const current_refs = document.querySelectorAll(
          ".ais-CurrentRefinements-category"
        );

        current_refs.forEach((ref) => {
          const ref_data = ref.dataset;
          if (ref_data.attribute == "price") {
            const item2 = Object.keys(ref.dataset).reduce(
              (acc, key) => ({
                ...acc,
                [key]: ref.dataset[key],
              }),
              {}
            );
            refine(item2);
          }
        });

        reset_price();
      }
    });
  });

  if (
    document.querySelectorAll(".ais-CurrentRefinements-category[data-attribute='price']").length <= 0
  ) {
    reset_price();
  }
};

const renderClearRefinements = (renderOptions, isFirstRender) => {
  const { hasRefinements, refine } = renderOptions;

  // --- Desktop clear-all button ---
  const container = document.querySelector("#clear-refinements");
  if (container) {
    if (!hasRefinements) {
      container.innerHTML = "";
    } else {
      // Render a clean button we fully control (no widget state we rely on).
      container.innerHTML = `
        <button type="button" class="ais-ClearRefinements-button makro-clear-all" aria-label="Clear all filters">
          <span>Clear all</span>
        </button>
      `;
      const btn = container.querySelector(".makro-clear-all");
      if (btn) {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          refine();
          if (typeof reset_price === "function") {
            try { reset_price(); } catch (err) { /* no-op */ }
          }
        });
      }
    }
  }

  // --- Mobile clear-all button (static markup in the section file) ---
  const mobileBtn = document.querySelector(".mobile-facets__clear");
  if (mobileBtn) {
    if (hasRefinements) {
      mobileBtn.removeAttribute("disabled");
      mobileBtn.classList.remove("is-disabled");
      mobileBtn.style.pointerEvents = "";
      mobileBtn.style.opacity = "";
    } else {
      mobileBtn.setAttribute("disabled", "");
      mobileBtn.classList.add("is-disabled");
      mobileBtn.style.pointerEvents = "none";
      mobileBtn.style.opacity = "0.4";
    }

    // handler always uses the current one (not a stale closure).
    mobileBtn._makroRefine = refine;

    // Only attach the click handler once.
    if (!mobileBtn.dataset.makroWired) {
      mobileBtn.dataset.makroWired = "1";
      mobileBtn.addEventListener("click", (e) => {
        e.preventDefault();
        if (typeof mobileBtn._makroRefine === "function") {
          mobileBtn._makroRefine();
        }
        if (typeof reset_price === "function") {
          try { reset_price(); } catch (err) { /* no-op */ }
        }
      });
    }
  }
};

const customClearRefinements = connectClearRefinements(renderClearRefinements);

const customStats = connectStats(renderStats);

const customSortBy = connectSortBy(renderSortBy);

const customSortBy2 = connectSortBy(renderSortBy2);

const customSearchBox = connectSearchBox(renderSearchBox);

const customRangeSlider = connectRange(renderRangeSlider);

const customRangeSliderMobile = connectRange(renderRangeSliderMobile);

const customCurrentRefinements = connectCurrentRefinements(renderCurrentRefinements);

const createDataAttribtues = (refinement) =>
  Object.keys(refinement)
    .map((key) => `data-${key}="${refinement[key]}"`)
    .join(" ");

const renderListItem = (item) => `<li class="ais-CurrentRefinements-item">${format_current_refined(item)}</li>`;
var close_icon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M12.5 3.42334L3.5 12.5696" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12.5 12.5696L3.5 3.42334" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

  const format_current_refined = (item) => {
    if (item.attribute == "price") {
      return `<button class="ais-CurrentRefinements-category" style="display:none" ${createDataAttribtues(
        item.refinements[0]
        
      )}></button><button class="ais-CurrentRefinements-category" ${createDataAttribtues(
        item.refinements[1]
        
      )}>
        $${item.refinements[0].value} - $${item.refinements[1].value}
        ${close_icon}
      </button>`;
    } else {
      return item.refinements
        .map(
          (refinement) =>
            `<button class="ais-CurrentRefinements-category" ${createDataAttribtues(
              refinement
              
            )}>
            <span class="ais-CurrentRefinements-label">${item.attribute
              .replace("meta.algolia.english.", "")
              .replace("meta.algolia.french.", "")}:</span>${refinement.label}
              ${close_icon}
          </button>`
        )
        .join("");
    }
  };

  const reset_price = () => {
    document.querySelector("#fromPrice").value = 0;
    document.querySelector("#toPrice").value = document.querySelector("#toPrice").getAttribute("max");
    const mobileFrom = document.querySelector("#fromPriceMobile");
    const mobileTo = document.querySelector("#toPriceMobile");
    if (mobileFrom) mobileFrom.value = 0;
    if (mobileTo) mobileTo.value = mobileTo.getAttribute("max");
  };

// Algolia card action helpers: live product hits expose variant count on variants_count
// and the selected Shopify variant ID on objectID.
const getAlgoliaData = (hit) => {
  if (hit.meta && hit.meta.custom && hit.meta.custom.algolia_data) {
    return hit.meta.custom.algolia_data;
  }

  return {};
};

const getAlgoliaVariantCount = (hit) => {
  const algoliaData = getAlgoliaData(hit);
  const count =
    hit.variants_count ||
    hit.variant_count ||
    hit.variantsCount ||
    algoliaData.variants_count ||
    algoliaData.variant_count ||
    algoliaData.variantsCount;

  if (count || count === 0) {
    const parsedCount = parseInt(count, 10);
    if (!isNaN(parsedCount)) {
      return parsedCount;
    }
  }

  if (Array.isArray(hit.variants)) {
    return hit.variants.length;
  }

  return null;
};

const getAlgoliaVariantId = (hit) => {
  const algoliaData = getAlgoliaData(hit);

  if (Array.isArray(hit.variants) && hit.variants.length === 1) {
    const variant = hit.variants[0];
    if (variant && typeof variant === "object") {
      return variant.id || variant.variant_id || variant.variantId || variant.objectID || null;
    }

    return variant;
  }

  return (
    hit.objectID ||
    hit.variant_id ||
    hit.variantId ||
    algoliaData.variant_id ||
    algoliaData.variantId ||
    algoliaData.default_variant_id ||
    algoliaData.defaultVariantId ||
    null
  );
};

const renderAlgoliaCardAction = (hit) => {
  const variantCount = getAlgoliaVariantCount(hit);
  const variantId = getAlgoliaVariantId(hit);

  if (variantCount === 1 && variantId) {
    return `
      <form method="post" action="/cart/add" class="algolia-card-action-form" novalidate="novalidate" data-type="add-to-cart-form" is="product-form">
        <input type="hidden" name="id" value="${variantId}" class="product-variant-id">
        <button type="submit" name="add" class="algolia-card-action-btn" aria-label="Add to cart">Add to cart</button>
      </form>
    `;
  }

  return `<a href="/products/${hit.handle}" class="algolia-card-action-btn">Choose options</a>`;
};
// End Algolia card action helpers.


const FACETS_ALLOWLIST = [
  'meta.custom.algolia_data.availability',
  'meta.custom.algolia_data.brand',
  'meta.custom.algolia_data.size',
  'meta.custom.algolia_data.color',
  'meta.custom.algolia_data.model',
  'meta.custom.algolia_data.length',
  'meta.custom.algolia_data.capacity',
  'meta.custom.algolia_data.type',
  'meta.custom.algolia_data.hardware',
  'meta.custom.algolia_data.front_d_ring',
  'meta.custom.algolia_data.front_d_rings',
  'meta.custom.algolia_data.side_d_ring',
  'meta.custom.algolia_data.side_d_rings',
  'meta.custom.algolia_data.cal_rating',
  'meta.custom.algolia_data.power_source',
  'meta.custom.algolia_data.cfm_delivered',
  'meta.custom.algolia_data.max_airflow',
  'meta.custom.algolia_data.thickness',
  'meta.custom.algolia_data.ratings',
  'meta.custom.algolia_data.uom'
];

const FACET_EXCLUDE_KEYS = [
  'sku',
  'mpn',
  'upc',
  'badge',
  'offer',
  'is_featured'
];

searchClient
.search([
  {
    indexName: 'jendco-shopify_products',
    params: new URLSearchParams({
      query: initialQuery,
      facets: JSON.stringify(FACETS_ALLOWLIST),
      hitsPerPage: '0',
      distinct: 'true',
      facetingAfterDistinct: 'true',
      filters: searchFilters()
    }).toString()
  }
])
.then(({ results }) => {
  const res = results && results[0] ? results[0] : {};
  let refinements = [];
  const facets = res.facets || {};
  let FacetKeys = Object.keys(facets).filter(facet => {
    const key = facet.split('.').pop();

    return (
      FACETS_ALLOWLIST.includes(facet) &&
      !FACET_EXCLUDE_KEYS.includes(key) &&
      hide_filters.includes(key) === false
    );
  });
  

  left_FILTERS = FacetKeys
    .filter(attr => {
      const facetValues = facets[attr];
      return facetValues && Object.keys(facetValues).length > 0;
    })
    .map(attr => {
      const key = attr.split('.').pop();
        return {
          label: toTitleCase(key.replace(/_/g, ' ')),
          attribute: attr
        };
    });

  // Sort sidebar filters in a defined priority order. Labels listed in
  // FILTER_ORDER appear first in this exact order; any filters not listed
  // here fall to the bottom in their natural order.
  // NOTE: Labels must match EXACTLY what renders in the sidebar. Labels are
  // auto-generated from the metafield key via toTitleCase, e.g.
  // `front_d_ring` → `Front D Ring`. To verify the current labels, run this
  // in the browser console on a collection page:
  //   [...document.querySelectorAll('.facets__wrapper-container .facets__summary-title')]
  //     .map(el => el.textContent.trim())
  const FILTER_ORDER = [
    'Availability',
    'Category',
    'Brand',
    'Size',
    'Color',
    'Model',
    'Length',
    'Capacity',
    'Type',
    'Hardware',
    'Front D Ring',
    'Side D Rings',
  ];

  left_FILTERS.sort((a, b) => {
    const indexA = FILTER_ORDER.indexOf(a.label);
    const indexB = FILTER_ORDER.indexOf(b.label);
    if (indexA === -1 && indexB === -1) return 0;
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;
    return indexA - indexB;
  });

  // if(left_FILTERS.length == 0){
  //   document.querySelector('.full-collection.enabled-sidebar').classList.remove('enabled-sidebar');
  // }
  left_FILTERS.forEach((filter, index) => {
    createSideFilter(filter, index, left_FILTERS.length)
  });
})
.catch(console.error);

if(isSearchPage){
  search_popular.addWidgets([
    configure({
      hitsPerPage: 10,
      distinct: true,
    }),
    hits({
      container: "#popular-prod",
      templates: {
        item(hit, { html, components }) {
          //console.log(hit,'hit')
          let title = hit.title;
          let sku_val = '',mpn_val = '',compare_val = '', badge = '', image = '', card_action = '';
          if(hit.meta.custom && hit.meta.custom.algolia_data.sku){
            sku_val = `<div class="pro-sku">SKU: ${hit.meta.custom.algolia_data.sku}</div>`;
          }
          if(hit.meta.custom && hit.meta.custom.algolia_data.mpn){
            mpn_val = `<div class="pro-mpn">MPN: ${hit.meta.custom.algolia_data.sku}</div>`;
          }
          const hasAttribute = (arr, key) => arr.some(obj => obj[key] && obj[key].trim() !== "");
          if(hit.price < hit.compare_at_price){
            compare_val = `<span><s class="price-item price-item--regular">${FoxTheme.Currency.formatMoney(hit.compare_at_price * 100,theme.moneyFormat)}</s></span>`;
          }

          if(hit.meta.custom && hit.meta.custom.algolia_data.badge){
            badge = `<div class="pro-top-tag">${hit.meta.custom.algolia_data.badge}</div>`
          }
          
          if(hit.image){
            image = `<a href="/products/${hit.handle}" class="product-item__image-wrapper product-item__image-wrapper--with-secondary"><img src="${hit.image}" alt="${title}"></a>`;
          }else{
            image = `<a href="/products/${hit.handle}" class="product-item__image-wrapper product-item__image-wrapper--with-secondary"><img src="https://cdn.shopify.com/s/files/1/0576/7803/7155/files/imageless.jpg" alt="${title}"></a>`;
          }
          // Algolia card action: render the image overlay without placing forms/buttons inside links.
          card_action = renderAlgoliaCardAction(hit);          

            return `
            <div class="product-grid-box algolia-product-grid-box" dataVid="${hit.objectID}" data-id="${hit.id}">
              ${badge}
              <div class="pro-img-info">
                <div class="algolia-card-media">
                  <div class="img-box">
                    ${image}
                  </div>
                  <div class="algolia-card-action-wrap">
                    ${card_action}
                  </div>
                </div>
                <div class="pro-item-info">
                  <div class="pro-brand-review">
                    <div class="pro-brand">${hit.vendor}</div>

                    <div class="" data-bv-show="inline_rating" data-bv-product-id="${hit.id}" data-bv-redirect-url="/products/${hit.handle}" data-bv-seo="false"></div>
                  </div>
                  <h4 class="product-grid-title">
                    <a href="/products/${hit.handle}" class="product-grid-title-link">${title}</a>
                  </h4>
                  <div class="sku-wrapper"> 
                    ${sku_val}${mpn_val}
                  </div>
                  <div class="pro-price-stock">
                    ${FoxTheme.Currency.formatMoney(hit.price * 100,theme.moneyFormat)}${compare_val}
                  </div>
                </div>
              </div>
            </div>
          `;
        },
      },
      cssClasses: {
        root: "swiper pop-product",
        item: "product-grid-col swiper-slide",
        list: "product-grid-list in-stock-wrap on-sale-wrap swiper-wrapper",
      },
    }),
  ])
  search_popular.on('render', () => {
    var pop_slider = new window.FoxTheme.Carousel(".pop-product", {
      slidesPerView: 2,
      navigation: {
        nextEl: document.querySelector('.popular-products .swiper-controls .swiper-button-next'),
        prevEl: document.querySelector('.popular-products .swiper-controls .swiper-button-prev'),
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
        1440:{
          slidesPerView: 4,
        }
      },
    });
    pop_slider.init();
  })
}


search.on('render', () => {
  
  if(isSearchPage){
    const results = search.helper.lastResults;
    const currentQuery = search.helper.state.query || '';
    qsClient
    .search(currentQuery, { hitsPerPage: 1 })
    .then(({ hits }) => {
      if (
        hits.length > 0 && hits.length == 1 &&
        hits[0].query.toLowerCase() !== currentQuery.toLowerCase()
      ) {
        const suggestion = hits[0].query;
        if(suggestionContainer){
          suggestionContainer.innerHTML = `
          Looking for ${suggestion}?
          <a href="/search?query=${suggestion}" class="search_collection-link__link link link--primary">Go to ${suggestion} collection 
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M5.25 2.1875L9.625 7L5.25 11.8125" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
          </a>
          `;
          suggestionContainer.parentElement.classList.remove('hide');
        }
      }else {
        if(suggestionContainer){
          suggestionContainer.textContent = '';
          suggestionContainer.parentElement.classList.add('hide'); 
        }
      }
    })
    .catch(err => {
      if(suggestionContainer){
        suggestionContainer.textContent = '';
        suggestionContainer.parentElement.classList.add('hide');
      }
    });
    
    if(results != null){
      if(results.hits.length == 0){
        var msg = 'No products found in this collection.';
        if(document.querySelector('.collection-template') == null){
          msg = 'No products found.';
        }
        document.querySelector('#FacetFiltersContainer').classList.add('!hidden');
        document.querySelector('#pagination').classList.add('!hidden');
        document.querySelector('.ais-SearchBox-submit').classList.add('!hidden');
        document.querySelector('.main-page-title').innerHTML = `No results found for <span>'${document.querySelector('.ais-SearchBox-input').value}'</span>`;
        // document.querySelector('.main-page-title').classList.add('!hidden');
        //document.querySelector('.search_heading-section').classList.add('active');
        //document.querySelector('.search-suggestion-tab').classList.remove('hide');
        document.querySelector('.collection').classList.add('!hidden');
        document.querySelector('.section-collection-list-slider').classList.remove('!hidden');
        document.querySelector('.popular-products').classList.remove('!hidden');

        qsClient
        .search(currentQuery, { hitsPerPage: 1 })
        .then(({ hits }) => {
          //console.log('dfjsdvfj',hits)
          if (hits.length > 1) {
            const suggestion = hits[0].query;
            if(suggestcollcontainer){
              suggestcollcontainer.querySelector('ul').innerHTML = `
                <li><a href="/search?query=${suggestion}">${suggestion}</a></li>
              `;
              suggestcollcontainer.classList.remove('hide');
            }
          }else {
            document.querySelector('.main-page-title').classList.add('alone');
            if(suggestcollcontainer){
              suggestcollcontainer.querySelector('ul').textContent = ''; 
            }
          }
        })
        .catch(err => {
          if(suggestcollcontainer){
            suggestcollcontainer.querySelector('ul').textContent = '';
          }
        });
        search_popular.start();
      }else if(results.hits.length < 6){
        for(var t=0;t<results.hits.length;t++){
          if(results.hits[t].meta['shopify--discovery--product_recommendation']){
            var store_original_data = `${results.hits[t].meta['shopify--discovery--product_recommendation']['complementary_products']}`;
            const productIds = JSON.stringify(JSON.parse(store_original_data).map(gid => gid.split('/').pop()));
            var store_id = getSearchQueryString(`${productIds}`);
            fetch(`/search?view=recently-viewed-products&type=product&q=${store_id}`, {
              credentials: 'same-origin',
              method: 'GET'
            })
            .then(response => response.text())
            .then(content => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(content, 'text/html');
              const targetElement = doc.querySelector('#you-may-like-prod');
              document.querySelector('#you-may-like-prod-data .swiper-wrapper').innerHTML += targetElement.innerHTML;
            })
          }
          
          if(t == (results.hits.length - 1)){
            document.querySelector('.you-may-like-products').classList.remove('!hidden');
            var pop_slider = new window.FoxTheme.Carousel(".you-may-like-products .swiper", {
              slidesPerView: 2,
              navigation: {
                nextEl: document.querySelector('.you-may-like-products .swiper-controls .swiper-button-next'),
                prevEl: document.querySelector('.you-may-like-products .swiper-controls .swiper-button-prev'),
              },
              breakpoints: {
                768: {
                  slidesPerView: 3,
                },
                1440:{
                  slidesPerView: 4,
                }
              },
            });
            pop_slider.init();
          }
        }
        document.querySelector('.main-page-title').classList.remove('alone');
        document.querySelector('.popular-products').classList.add('!hidden');
        document.querySelector('.section-collection-list-slider').classList.add('!hidden');
        document.querySelector('.search-suggestion-tab').classList.add('hide');
        document.querySelector('.collection').classList.remove('!hidden');
        document.querySelector('#FacetFiltersContainer').classList.remove('!hidden');
        document.querySelector('#pagination').classList.remove('!hidden');
        if(document.querySelector('.ais-SearchBox-input').value.trim().length > 0){
          document.querySelector('.ais-SearchBox-submit').classList.add('!hidden');
          document.querySelector('.main-page-title').innerHTML = `${document.querySelector('#ProductCount').dataset.count} Results for <span>'${document.querySelector('.ais-SearchBox-input').value}'</span>`;
          document.querySelector('.main-page-title').classList.remove('!hidden');
          // document.querySelector('.search_heading-section').classList.remove('active');
        }else{
          document.querySelector('.ais-SearchBox-submit').classList.remove('!hidden');
          document.querySelector('.main-page-title').classList.add('!hidden');
          // document.querySelector('.search_heading-section').classList.add('active');
        }
      }else{
        document.querySelector('.you-may-like-products').classList.add('!hidden');
        document.querySelector('.main-page-title').classList.remove('alone');
        document.querySelector('.popular-products').classList.add('!hidden');
        document.querySelector('.section-collection-list-slider').classList.add('!hidden');
        document.querySelector('.search-suggestion-tab').classList.add('hide');
        document.querySelector('.collection').classList.remove('!hidden');
        document.querySelector('#FacetFiltersContainer').classList.remove('!hidden');
        document.querySelector('#pagination').classList.remove('!hidden');
        if(document.querySelector('.ais-SearchBox-input').value.trim().length > 0){
          document.querySelector('.ais-SearchBox-submit').classList.add('!hidden');
          document.querySelector('.main-page-title').innerHTML = `${document.querySelector('#ProductCount').dataset.count} Results for <span>'${document.querySelector('.ais-SearchBox-input').value}'</span>`;
          document.querySelector('.main-page-title').classList.remove('!hidden');
          // document.querySelector('.search_heading-section').classList.remove('active');
        }else{
          document.querySelector('.ais-SearchBox-submit').classList.remove('!hidden');
          document.querySelector('.main-page-title').classList.add('!hidden');
          // document.querySelector('.search_heading-section').classList.add('active');
        }
      }
    }
  }
})

var r = "";

sideFilterWrapper.forEach((all_price_filter) => {
  all_price_filter.innerHTML += `
  <details class="disclosure-has-popup facets__filter-dropdown facets__disclosure js-filter" id="price-facet" data-index="00">
    <summary class="facets__summary focus-inset" role="button" aria-expanded="false" aria-controls="Facet-00">
      <div class="facets__summary-inner">
        <div class="facets__summary-title re-le-sp-2 font-blod">Price</div>
        <div class="facets__summary-icon">
          <svg class="icon icon-minus" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M2.5 10L8 5L13.5 10" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>

          <svg class="icon icon-plus" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M2.5 6L8 11L13.5 6" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
    </summary>
    <div id="Facet-00" class="facets__display">
      <div class="panel" id="range-slider"><div class="sliders_control"></div></div>
    </div>
  </details>
  `;
})

facetsWrappermobile.forEach((mobileFilterWrapper) => {
  const mobilePriceFilter = document.createElement('details');
  mobilePriceFilter.className = 'mobile-facets__details js-filter';
  mobilePriceFilter.id = 'mobile-price-facet';
  mobilePriceFilter.setAttribute('data-index', 'mobile-algolia-price');
  mobilePriceFilter.innerHTML = `
    <summary class="mobile-facets__summary" role="button" aria-expanded="false" aria-controls="FacetMobile-Mobile-price">
      <div>
        <span>Price</span>
        <span class="mobile-facets__arrow no-js-hidden">
          <svg class="icon icon-caret" xmlns="http://www.w3.org/2000/svg" width="13" height="7" viewBox="0 0 13 7" fill="none">
            <path d="M0.600098 0.600098L6.1001 5.6001L11.6001 0.600098" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
        <noscript>
          <svg class="icon icon-caret" xmlns="http://www.w3.org/2000/svg" width="13" height="7" viewBox="0 0 13 7" fill="none">
            <path d="M0.600098 0.600098L6.1001 5.6001L11.6001 0.600098" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </noscript>
      </div>
    </summary>
    <div id="FacetMobile-Mobile-price" class="mobile-facets__submenu">
      <button class="mobile-facets__close-button link link--text focus-inset" aria-expanded="true" type="button">
        <svg class="icon icon-caret" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.5 1L5 4.5L8.5 1" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
        Price
      </button>
      <div class="mobile-facets__submenu-items" id="Facet-mobile-price">
        <div class="panel" id="range-slider-mobile"><div class="sliders_control_mobile"></div></div>
      </div>
    </div>
  `;
  mobileFilterWrapper.appendChild(mobilePriceFilter);
});

search.addWidgets([
  customRangeSlider({
    container: document.querySelector(".sliders_control"),
    attribute: "price",
  }),
]);

search.addWidgets([
  customRangeSliderMobile({
    container: document.querySelector(".sliders_control_mobile"),
    attribute: "price",
  }),
]);

search.addWidgets([
  searchBox({
  container: "#searchbox",
  placeholder: "Search for products",
  queryHook(query, search) {
    search(query);
  },
    templates: {
      submit({ cssClasses }, { html }) {
        return html`<svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none"><path d="M5.66457 11.501C6.84789 11.5008 7.99711 11.1046 8.92924 10.3757L11.8599 13.3063L12.8026 12.3637L9.87191 9.43302C10.6012 8.50079 10.9976 7.35131 10.9979 6.16768C10.9979 3.22702 8.60524 0.834351 5.66457 0.834351C2.7239 0.834351 0.331238 3.22702 0.331238 6.16768C0.331238 9.10835 2.7239 11.501 5.66457 11.501ZM5.66457 2.16768C7.87057 2.16768 9.66457 3.96168 9.66457 6.16768C9.66457 8.37368 7.87057 10.1677 5.66457 10.1677C3.45857 10.1677 1.66457 8.37368 1.66457 6.16768C1.66457 3.96168 3.45857 2.16768 5.66457 2.16768Z" fill="#001424"></path></svg>`;
      },
    },
  }),
  customCurrentRefinements({
    container: "#current-refinements",
  }),
  // clearRefinements({
  //   container: "#clear-refinements",
  //   templates: {
  //     resetLabel({ hasRefinements }, { html }) {
  //       return html`<span>${
  //         hasRefinements ? "Clear all" : "Clear all"
  //       }</span>`;
  //     },
  //   },
  // }),
  customClearRefinements({}),
  configure({
    hitsPerPage: 20,
    distinct: true,
    facetingAfterDistinct: true,
    filters: searchFilters(),
  }),
  customSortBy({
    container: document.querySelector("#sort-by1"),
    items: [
      {
        label: "Relevance",
        value: "jendco-shopify_products",
      },
      {
        label: "Price: Low to High",
        value: "jendco-shopify_products_price_asc",
      },
      {
        label: "Price: High to Low",
        value: "jendco-shopify_products_price_desc",
      },
      {
        label: "Best Selling",
        value: "shopify_best_selling",
      },
      {
        label: "Newest",
        value: "shopify_newest",
      },
      {
        label: "Name: A-Z",
        value: "shopify_az",
      },
      {
        label: "Name: Z-A",
        value: "shopify_za",
      },
    ],
  }),
  customSortBy2({
    container: document.querySelector("#sort-by2"),
    items: [
      {
        label: "Relevance",
        value: "jendco-shopify_products",
      },
      {
        label: "Price: Low to High",
        value: "jendco-shopify_products_price_asc",
      },
      {
        label: "Price: High to Low",
        value: "jendco-shopify_products_price_desc",
      },
      {
        label: "Best Selling",
        value: "shopify_best_selling",
      },
      {
        label: "Newest",
        value: "shopify_newest",
      },
      {
        label: "Name: A-Z",
        value: "shopify_az",
      },
      {
        label: "Name: Z-A",
        value: "shopify_za",
      },
    ],
  }),
  customStats({
    container: document.querySelector("#ProductCount"),
    templates: {
      resetLabel({ hasRefinements }, { html }) {
        return html`<span>${
          hasRefinements ? "Clear all" : "Clear all"
        }</span>`;
      },
    }
  }),
  hits({
    container: "#ProductGridContainer",
    templates: {
      item(hit, { html, components }) {
        //console.log(hit.meta.custom.algolia_data,'hit')
        let title = hit.title;
        let sku_val = '',mpn_val = '',compare_val = '', badge = '', image = '', chk_sku = '', card_action = '';
        if(hit.meta.custom && hit.meta.custom.algolia_data.sku){
          sku_val = `<div class="pro-sku">SKU: ${hit.meta.custom.algolia_data.sku}</div>`;
          chk_sku = 'active';
        }
        if(hit.meta.custom && hit.meta.custom.algolia_data.mpn){
          mpn_val = `<div class="pro-mpn">MPN: ${hit.meta.custom.algolia_data.mpn}</div>`;
        }
        const hasAttribute = (arr, key) => arr.some(obj => obj[key] && obj[key].trim() !== "");
        if(hit.price < hit.compare_at_price){
          compare_val = `<span><s class="price-item price-item--regular">${FoxTheme.Currency.formatMoney(hit.compare_at_price * 100,theme.moneyFormat)}</s></span>`;
        }

        if(hit.meta.custom && hit.meta.custom.algolia_data.badge){
          badge = `<div class="pro-top-tag">${hit.meta.custom.algolia_data.badge}</div>`
        }
        
        if(hit.image){
          image = `<a href="/products/${hit.handle}" class="product-item__image-wrapper product-item__image-wrapper--with-secondary"><img src="${hit.image}" alt="${title}"></a>`;
        }else{
          image = `<a href="/products/${hit.handle}" class="product-item__image-wrapper product-item__image-wrapper--with-secondary"><img src="https://cdn.shopify.com/s/files/1/0576/7803/7155/files/imageless.jpg" alt="${title}"></a>`;
        }
        
        // Algolia card action: render the image overlay without placing forms/buttons inside links.
        card_action = renderAlgoliaCardAction(hit);
          return `
          <div class="product-grid-box algolia-product-grid-box" dataVid="${hit.objectID}" data-id="${hit.id}">
            ${badge}
            <div class="pro-img-info">
              <div class="algolia-card-media">
                <div class="img-box">
                  ${image}
                </div>
                <div class="algolia-card-action-wrap">
                  ${card_action}
                </div>
              </div>
              <div class="pro-item-info">
                <div class="pro-brand-review">
                  <div class="pro-brand">${hit.vendor}</div>

                  <div class="" data-bv-show="inline_rating" data-bv-product-id="${hit.id}" data-bv-redirect-url="/products/${hit.handle}" data-bv-seo="false"></div>
                </div>
                <h4 class="product-grid-title">
                  <a href="/products/${hit.handle}" class="product-grid-title-link">${title}</a>
                </h4>
                <div class="sku-wrapper ${chk_sku}"> 
                  ${sku_val}${mpn_val}
                </div>
                <div class="pro-price-stock">
                  ${FoxTheme.Currency.formatMoney(hit.price * 100,theme.moneyFormat)}${compare_val}
                  </div>
                </div>
              </div>
            </div>
          </div>
        `;
      },
    },
    cssClasses: {
      item: "product-grid-col",
      list: "product-grid-list in-stock-wrap on-sale-wrap",
    },
  }),
  pagination({
    container: "#pagination",
    showFirst: false,
    showLast: false,
    templates: {
      previous: '< Prev',
      next: 'Next >',
    },
  }),
]);

search.start();





if (initialQuery) {
  search.helper.setQuery(initialQuery).search();
  // console.log(initialQuery,'initialQuerytext')
  // document.querySelector('.main-page-title').innerHTML = `${document.querySelector('#ProductCount').dataset.count} Results for <span>'${initialQuery}'</span>`;
  //document.querySelector('.main-page-title').innerText = 'Search Results for "' + initialQuery + '"';
  // document.querySelector('.header__left .search-box form input').value = initialQuery;
}

const selectedFiltersContainer = document.querySelector('.active-facets');

document.addEventListener("algolia.autocomplete.afterInit", function () {
  console.log("Autocomplete.js has been initialized");
});

function toTitleCase(str) {
  return str.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substring(1));
}

function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
  const rangeDistance = to.max - to.min;
  const fromPosition = from.value - to.min;
  const toPosition = to.value - to.min;
  controlSlider.style.background = `linear-gradient(
      to right,
      ${sliderColor} 0%,
      ${sliderColor} ${(fromPosition / rangeDistance) * 100}%,
      ${rangeColor} ${(fromPosition / rangeDistance) * 100}%,
      ${rangeColor} ${(toPosition / rangeDistance) * 100}%, 
      ${sliderColor} ${(toPosition / rangeDistance) * 100}%, 
      ${sliderColor} 100%)`;
}

function toggleClass(ele){
  ele.classList.toggle('active');
}

function closeActive(ele){
  document.querySelector('.selected-sort').textContent = ele.textContent;
  document.querySelector('.selected-sort').classList.remove('active')
}

function createSideFilter(filter, index, total) {

  var class_name = '';
  if(filter.label == 'Availability'){
    class_name = 'facet_availability';
  }
    
  if(document.querySelector('#col_side_filter') && document.querySelector('#col_side_filter').value != ''){
    var curr_filter = filter.label.toLocaleLowerCase().replaceAll(' ','-');
    var side_filter_ignor = document.querySelector('#col_side_filter').value.toLocaleLowerCase().replaceAll(' ','-').split(',');
    if(side_filter_ignor.includes(curr_filter)){
      return;
    }
  }
  const wrapper = document.createElement('details');
  wrapper.className = `disclosure-has-popup facets__filter-dropdown facets__disclosure js-filter ${class_name}`;
  wrapper.id = `Details-sidefilter-${index}`;
  wrapper.setAttribute('data-index', index);

  wrapper.innerHTML = `
    <summary class="facets__summary focus-inset" role="button" aria-expanded="false" aria-controls="Facet-${index}">
      <div class="facets__summary-inner">
        <div class="facets__summary-title re-le-sp-2 font-blod">${filter.label}</div>
        <div class="facets__summary-icon">
          <svg class="icon icon-minus" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M2.5 10L8 5L13.5 10" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>

          <svg class="icon icon-plus" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M2.5 6L8 11L13.5 6" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
    </summary>
    <div id="Facet-${index}" class="facets__display">
      <ul class="facets__list list-unstyled ${class_name}" role="list" id="side-facet-list-${index}"></ul>
    </div>
  `;

  const wrappermobile = document.createElement('details');
  wrappermobile.className = 'mobile-facets__details js-filter';
  wrappermobile.id = `Details-Mobile-${index}`;
  wrappermobile.setAttribute('data-index', `mobile-algolia-${index}`);

  wrappermobile.innerHTML = `<summary class="mobile-facets__summary" role="button" aria-expanded="false" aria-controls="FacetMobile-Mobile-${index}">
        <div>
          <span>${filter.label}</span>
          <span class="mobile-facets__arrow no-js-hidden">
            <svg class="icon icon-caret"  xmlns="http://www.w3.org/2000/svg" width="13" height="7" viewBox="0 0 13 7" fill="none">
              <path d="M0.600098 0.600098L6.1001 5.6001L11.6001 0.600098" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          <noscript>
            <svg class="icon icon-caret"  xmlns="http://www.w3.org/2000/svg" width="13" height="7" viewBox="0 0 13 7" fill="none">
              <path d="M0.600098 0.600098L6.1001 5.6001L11.6001 0.600098" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </noscript>
        </div>
      </summary>
      <div id="FacetMobile-Mobile-${index}" class="mobile-facets__submenu">
        <button class="mobile-facets__close-button link link--text focus-inset" aria-expanded="true" type="button">
          <svg class="icon icon-caret" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.5 1L5 4.5L8.5 1" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
          ${filter.label}
        </button>
        <div class="mobile-facets__submenu-items" id="Facet-mobile-${index}">
          <ul class="mobile-facets__list list-unstyled" role="list" style="--image_filter_columns: 4;" id="side-facet-list-mobile-${index}"></ul>
        </div>
      </div>`

  sideFilterWrapper.forEach((filterwrapper) =>{
    filterwrapper.appendChild(wrapper);
  })

  facetsWrappermobile.forEach((filterwrappermobile) =>{
    filterwrappermobile.appendChild(wrappermobile);
  })

  // if(index == (total - 1)){
  //   customElements.define('menu-drawer', MenuDrawer)
  // }

  search.addWidgets([
    instantsearch.connectors.connectRefinementList((renderOptions, isFirstRender) => {
      var store_original_index = index;
      const { items, refine } = renderOptions;
      const ul = document.getElementById(`side-facet-list-${store_original_index}`);
      ul.innerHTML = '';

      // For the Availability filter, hide the "Back in Stock Soon" value.
      // Only "In Stock" should be exposed to shoppers.
      let filteredItems = items;
      if (filter.attribute === 'meta.custom.algolia_data.availability') {
        filteredItems = items.filter(item =>
          item.label.toLowerCase() !== 'back in stock soon'
        );
      }

      // Sort: (1) active/refined items on top,
      //       (2) for Yes/No filters, Yes before No,
      //       (3) otherwise alphabetical A–Z.
      const sortedItems = [...filteredItems].sort((a, b) => {
        if (a.isRefined && !b.isRefined) return -1;
        if (!a.isRefined && b.isRefined) return 1;
        const aLower = a.label.toLowerCase();
        const bLower = b.label.toLowerCase();
        if (aLower === 'yes' && bLower === 'no') return -1;
        if (aLower === 'no' && bLower === 'yes') return 1;
        return a.label.localeCompare(b.label, undefined, {
          numeric: true,
          sensitivity: 'base',
        });
      });

      sortedItems.forEach((item,index) => {
        const li = document.createElement('li');
        if(index > 4){
          li.className = 'list-menu__item facets__item !hidden';
        }else{
          li.className = 'list-menu__item facets__item';
        }
        
        const id = `Filter-${store_original_index}-${item.label.replace(/\s+/g, '-')}`;

        let label = item.label;
        li.innerHTML = `
          <input type="checkbox" class="focus-inset" value="${item.value}" id="${id}" ${item.isRefined ? 'checked' : ''}>
          <label for="${id}" class="facet-checkbox re-le-sp-1">
            <span class="icon icon-checkmark"></span>
            <span class="facet-checkbox__label">${label}</span>
            
          </label>
          <span class="value-count">(${item.count})</span>
        `;

        li.querySelector('input').addEventListener('change', () => {
          refine(item.value);
          // Update UI after checkbox change
          // updateFilterUI(wrapper, filter.attribute); // Removed this line
        });

        ul.appendChild(li);
        
      });

      if(items.length > 5){
        const closestDisplay = ul.closest('.facets__display');
        if (closestDisplay) {
          const oldButton = closestDisplay.querySelector('span.show_more-button');
          if(oldButton) oldButton.remove();
        }
        const showMoreContainer = document.createElement('span');
        showMoreContainer.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none" class="icon icon-plus">
            <path d="M5.83329 0.833333C5.83329 0.373096 5.4602 0 4.99996 0C4.53972 0 4.16663 0.373096 4.16663 0.833333L4.16663 9.16667C4.16663 9.6269 4.53972 10 4.99996 10C5.4602 10 5.83329 9.6269 5.83329 9.16667L5.83329 0.833333Z" fill="currentColor"></path>
            <path d="M9.16667 5.83341C9.6269 5.83341 10 5.46032 10 5.00008C10 4.53984 9.6269 4.16675 9.16667 4.16675L0.833334 4.16675C0.373096 4.16675 0 4.53984 0 5.00008C0 5.46032 0.373096 5.83341 0.833334 5.83341L9.16667 5.83341Z" fill="currentColor"></path>
          </svg>
          <span class="text">Show more</span>
          <span class="num-of_filter" data-number="${(items.length - 5)}"></span>`;
        showMoreContainer.className = 'show_more-button';
        showMoreContainer.onclick = ShowMore;
        if (closestDisplay) closestDisplay.appendChild(showMoreContainer);
      }

      if(items.length == 0){
        wrapper.classList.add('hidden');
      }else{
        wrapper.classList.remove('hidden');
      }

      // Initial UI update
      if (!isFirstRender) {
        //updateFilterUI(wrapper, filter.attribute);
      }

    })({
      container: `#side-facet-list-${index}`,
      attribute: filter.attribute,
      limit: 100
    })
  ]);

  search.addWidgets([
    instantsearch.connectors.connectRefinementList((renderOptions, isFirstRender) => {
      var store_original_index = index;
      const { items, refine } = renderOptions;
      const ul = document.getElementById(`side-facet-list-mobile-${store_original_index}`);
      ul.innerHTML = '';

      // For the Availability filter, hide the "Back in Stock Soon" value.
      // Only "In Stock" should be exposed to shoppers.
      let filteredItems = items;
      if (filter.attribute === 'meta.custom.algolia_data.availability') {
        filteredItems = items.filter(item =>
          item.label.toLowerCase() !== 'back in stock soon'
        );
      }

      // Sort: (1) active/refined items on top,
      //       (2) for Yes/No filters, Yes before No,
      //       (3) otherwise alphabetical A–Z.
      const sortedItems = [...filteredItems].sort((a, b) => {
        if (a.isRefined && !b.isRefined) return -1;
        if (!a.isRefined && b.isRefined) return 1;
        const aLower = a.label.toLowerCase();
        const bLower = b.label.toLowerCase();
        if (aLower === 'yes' && bLower === 'no') return -1;
        if (aLower === 'no' && bLower === 'yes') return 1;
        return a.label.localeCompare(b.label, undefined, {
          numeric: true,
          sensitivity: 'base',
        });
      });

      sortedItems.forEach(item => {
        const li = document.createElement('li');
        li.className = 'list-menu__item facets__item';
        const id = `Filter-${store_original_index}-${item.label.replace(/\s+/g, '-')}`;

        let label = item.label;
        li.innerHTML = `
          <input type="checkbox" class="focus-inset" value="${item.value}" id="${id}" ${item.isRefined ? 'checked' : ''}>
          <label for="${id}" class="facet-checkbox re-le-sp-1">
            <span class="icon icon-checkmark"></span>
            <span class="facet-checkbox__label">${label}</span>
            
          </label>
          <span class="value-count">(${item.count})</span>
        `;

        li.querySelector('input').addEventListener('change', () => {
          refine(item.value);
          // Update UI after checkbox change
          // updateFilterUI(wrapper, filter.attribute); // Removed this line
        });

        ul.appendChild(li);
      });

      if(items.length == 0){
        wrappermobile.classList.add('hidden');
      }else{
        wrappermobile.classList.remove('hidden');
      }

      // Initial UI update
      if (!isFirstRender) {
        //updateFilterUI(wrapper, filter.attribute);
      }

    })({
      container: `#side-facet-list-mobile-${index}`,
      attribute: filter.attribute,
      limit: 100
    })
  ]);
}

function ShowMore(ele){
  const ul = ele.target.closest('.facets__display').querySelector('ul');
  const liItems = ul.querySelectorAll('li');
  const showMoreBtn = ele.target;
  showMoreBtn.classList.toggle('active');

  const anyHidden = Array.from(liItems).some(li => li.classList.contains('!hidden'));

  if (anyHidden) {
    liItems.forEach(li => li.classList.remove('!hidden'));
    showMoreBtn.textContent = 'Show less';
  } else {
    liItems.forEach((li, i) => {
      if (i > 4) {
        li.classList.add('!hidden');
      }
    });
    showMoreBtn.textContent = 'Show more';
  }
}

function getSearchQueryString(dataItems) {
  let items = JSON.parse(dataItems);

  return items.map(item => `id:${item}`).join(' OR ');
}
}